import SearchBox from 'components/common/SearchBox';

interface ListPageHeaderProps {
  title: string;
  as?: 'h1' | 'h2';
}

export default function ListPageHeader({ title, as: Tag = 'h1' }: ListPageHeaderProps) {
  return (
    <div className="flex w-full flex-col gap-4 pad:flex-row pad:items-center pad:justify-between pad:gap-0">
      <Tag className="text-[28px] font-bold leading-[34px] text-base-label pad:text-6xl pad:leading-[44px]">
        {title}
      </Tag>
      <SearchBox size="compact" className="w-full pad:w-[288px]" />
    </div>
  );
}
